module.exports = __webpack_public_path__ + "static/media/SFProDisplay-Black.bc43a493.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SFPro/TrueType/SFProDisplay-Black.ttf
// module id = 2545
// module chunks = 7